import backpackImage from '../../assets/images/setupPurposeBackpack.png'
import backpackImage2x from '../../assets/images/setupPurposeBackpack@2x.png'

interface BackpackIconProps {
  size?: number
  className?: string
}

/**
 * Rucksack über der Setup-Seite „Wofür möchtest du HappyTask nutzen?“
 * (thiings.co, lizenziert; 25.09.2026 statt des Ordners). Dekorativ, `alt` bleibt leer.
 */
export const BackpackIcon = ({ size = 100, className = '' }: BackpackIconProps) => (
  <img
    src={backpackImage}
    srcSet={`${backpackImage} 1x, ${backpackImage2x} 2x`}
    alt=""
    width={size}
    height={size}
    className={className}
  />
)
